module.exports = __webpack_public_path__ + "static/purple-ee0f6498b2f30a59b20155a5c063bd13.png";